import React from 'react';
import { useGetProcurementOrdersQuery } from '../../../store/endpoints/ProcurementEndpoints';
import AutocompleteSearchBox, { ISuggestionItem } from '../../Common/AutocompleteSearchBox';
import { IProcurementOrder } from '../../../models/Procurement';

interface IExistingOrderSearchProps {
    vendor?: string;
    selectedOrderId?: string;
    onOrderSelected: (order: IProcurementOrder) => void;
}

const ExistingOrderSearch: React.FC<IExistingOrderSearchProps> = (props) => {
    const recentOrders = useGetProcurementOrdersQuery({ conditions: {
        pageSize: 50,
        sortBy: 'lastUpdated',
        sortDirection: 'desc',
        filters: {
            'status': 'Pending',
            ...(props.vendor ? { 'vendor': props.vendor } : {})
        }
    } });
    const [suggestions, setSuggestions] = React.useState<ISuggestionItem[]>([]);
    const [searchTerm, setSearchTerm] = React.useState<string>('');

    React.useEffect(() => {
        const orderSuggestions: ISuggestionItem[] = [];
        if (recentOrders.data) {
            recentOrders.data.items.forEach((order) => {
                orderSuggestions.push(new ProcurementOrderSuggestion(order));
            });
        }
        // Filter suggestions based on search term
        const filteredSuggestions = orderSuggestions.filter((suggestion) => {
            const searchText = suggestion.getSearchText().toLowerCase();
            return searchText.includes(searchTerm.toLowerCase());
        });
        setSuggestions(filteredSuggestions);
    }, [recentOrders.data, searchTerm]);

    return <div>
        <AutocompleteSearchBox
            placeholder="Search Existing Orders..."
            suggestions={suggestions}
            onSuggestionClicked={(suggestion) => {
                if (typeof suggestion === 'string') {
                    const order = recentOrders.data?.items.find(o => o.id === suggestion);
                    if (order) props.onOrderSelected(order);
                } else {
                    const order = recentOrders.data?.items.find(o => o.id === suggestion.getKey());
                    if (order) props.onOrderSelected(order);
                }
            }}
            onChange={(ev, newValue) => {
                setSearchTerm(newValue || '');
            }}
        />

    </div>;
}

class ProcurementOrderSuggestion implements ISuggestionItem {
    private order: IProcurementOrder;

    constructor(order: IProcurementOrder) {
        this.order = order;
    }

    getSuggestionItem(query?: string): JSX.Element {
        return <div>
            {this.order.name ? `${this.order.name} - ` : null} {this.order.vendor} - {this.order.purchaseOrderNumber ? `PO: #${this.order.purchaseOrderNumber} -` : ''} {new Date(this.order.createDate || '').toLocaleDateString()}
        </div>;
    }

    getSearchText(): string {
        return `${this.order.purchaseOrderNumber || ''} ${this.order.vendor} ${this.order.name || ''} - ${new Date(this.order.createDate || '').toLocaleDateString()}`;
    }

    getKey(): string {
        return this.order.id || '';
    }
}

export default ExistingOrderSearch;